<template>
  <!--
        作者：kmdshop
        时间：2019-10-25
        描述：权限-管理员列表
    -->
  <div class="user">
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="product_id" label="用户" width="300px">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.user.avatarUrl?scope.row.user.avatarUrl:error_img" alt="" /></div>
                <div class="info">
                  <div class="name">{{ scope.row.user.nickName }}({{scope.row.user.user_id}})</div>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="amount" label="冻结积分">
              <template slot-scope="scope">
                  <div>{{ scope.row.amount }}</div>
              </template>
          </el-table-column>
          <el-table-column prop="release_amount" label="解冻积分">
              <template slot-scope="scope">
                  <div>{{ scope.row.release_amount }}</div>
              </template>
          </el-table-column>
          <el-table-column prop="release_rate" label="当前释放速度">
              <template slot-scope="scope">
                  <div>{{ scope.row.release_rate }}</div>
              </template>
          </el-table-column>
          <el-table-column prop="create_time" label="添加时间"></el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import PointsreleaseApi from '@/api/pointsrelease.js';
export default {
  components: {
  },
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*角色是否加载完成*/
      role_loading:true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        user: '',
        region: ''
      },
     
      /*是否多选*/
      islist: false,
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = {};
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      PointsreleaseApi.getRelease(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
          self.role_loading = false;
        })
        .catch(error => {});
    },

    /*打开添加*/
    addClick() {
      if(!this.role_loading){
         this.open_add=true;
      }
    },

    /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.curAddModel.product = {};
      this.curAddModel.product_id = 0;
      if(e.type=='success'){
        this.getTableList();
      }
    },

    /*打开编辑*/
    editClick(row) {
      console.log(row);
      this.curModel = row;
      this.grade_list = row.grade_list;
      this.open_edit=true;
    },

    /*关闭添加*/
    closeEdit(e){
      this.open_edit=false;
      this.curModel = {
        id: 0,
        product: {},
        product_id: 0,
        award_type: 0, //奖励类型
        type: 0, //计算类型
        award: 0,
        status: 0,
        award_detail: {},
      };
      this.grade_list = [];
      if(e.type=='success'){
        this.loading = false;
        this.tableData = [];
        this.curPage = 1;
        this.getTableList();
      }
    },


    /*商品选择列表弹出层*/
    openProduct(product, islist) {
      if(product){
        this.excludeIds = [product.product_id];
      }
      this.islist = false;
      this.isproduct = true;
    },

    // /*商品选择关闭弹窗*/
    closeProductDialogFunc(e) {
      if (this.curAddModel == null) {
        return;
      }
      this.isproduct = false;
      if (e.type == 'success') {
        console.log(e)
        this.curAddModel.product= { product_id: e.params.product_id, product_image: e.params.product_image,product_name: e.params.product_name,product_price: e.params.product_price };
        this.curAddModel.product_id = e.params.product_id;
      }
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          PointsreleaseApi.delProduct(
            {
              id: row.id
            },
            true
          )
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: '删除成功',
                  type: 'success'
                });
                //刷新页面
                self.getTableList();
              } else {
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {});
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/pointsrelease/product/release.vue